/**
 * Span analog of buildModularFilters. Produces the API-bound
 * `modularFilters` array for the Trace page query builder.
 *
 * Differences from the runs version:
 *   - "selectedAgents" is replaced by "selectedTraces" — the Trace section
 *     in the UI lets the user pick one or more span names. We emit them as
 *     a single { field: 'name', operator: 'is', value: [<names>],
 *     category: 'traces' } chip the backend expands to `name = ANY($)`.
 *   - "agentScopedFilters" become "traceScopedFilters" — each chip is
 *     scoped to one specific span name via `traceName`. The backend treats
 *     them as plain span_property filters with an extra `name = ?` AND.
 *
 * Local-only fields (id, traceId, _justAdded, sampleValues) are stripped.
 * `source` maps to the same propertyType branches the backend uses to
 * decide fixed-column vs JSONB-attribute vs metadata-JSONB lookup.
 */
const asList = (v) => (Array.isArray(v) ? v : []);

export default function buildSpanModularFilters({
  selectedTraces = [],
  traceScopedFilters = [],
  globalFilters = [],
}) {
  const out = [];
  if (asList(selectedTraces).length > 0) {
    out.push({
      field: 'name',
      operator: 'is',
      value: asList(selectedTraces).map((t) => t.traceName),
      category: 'traces',
    });
  }
  const clean = (f) => {
    const { id, traceId, agentId, _justAdded, sampleValues, ...rest } = f;
    const propertyType =
      rest.source === 'attributes' || rest.source === 'span_attributes'
        ? 'custom'
        : rest.source === 'metadata'
          ? 'metadata'
          : rest.source === 'user'
            ? 'custom'
            : 'fixed';
    return { ...rest, propertyType };
  };
  // A list that is not a list (a stray setter value) contributes nothing rather than crashing the page.
  out.push(...asList(traceScopedFilters).map(clean));
  out.push(...asList(globalFilters).map(clean));
  return out;
}
